export function mapPaymentError(error) {
  const code = error?.response?.data?.errorCode;

  switch (code) {
    case 'CARD_DECLINED':
      return 'Cartão recusado. Verifique os dados ou tente outro cartão.';

    case 'INVALID_CARD':
      return 'Os dados do cartão são inválidos.';

    case 'INSUFFICIENT_FUNDS':
      return 'Saldo insuficiente para concluir o pagamento.';

    case 'PIX_EXPIRED':
      return 'O código PIX expirou. Gere um novo pagamento.';

    case 'DUPLICATE_PAYMENT':
      return 'Este pagamento já foi processado.';

    default:
      return 'Não foi possível processar o pagamento. Tente novamente.';
  }
}